<template>
  <div class="c_goods_container">
    <div class="c_goods_header">
      <span class="c_goods_title">{{title}}</span>
    </div>
    <div class="c_goods__divider"></div>
    <div class="c_goods"
         @mousedown="startDrag($event)"
         @mousemove.prevent="moveOnDrag($event)"
         @mouseup="onDrop($event)"
         @mouseleave="onDrop($event)"
         ref="scrollGoodsContainer"
    >
      <template v-for="item in goodsArray">
        <CatalogElement
            :id="item.id"
            :title="item.title"
            :actual-price="item.actualPrice.toString()"
            :full-price="item.fullPrice.toString()"
            :discount="item.discount.toString()"
            :count="item.count"
            :images="item.itemImages ? item.itemImages : []"
        ></CatalogElement>
      </template>
    </div>
  </div>
</template>

<script>
import CatalogElement from "@/components/UI/CatalogElement";
export default {
  name: "GoodsSection",
  components: {CatalogElement},
  props:{
    goodsArray:{
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Блок товаров'
    }
  },
  data(){
    return {
      selectedIndex: 0,
      dragging: false,
      startDragPos: 0,
      progressDragPos: 0,

      resizeTimeout: null
    }
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  mounted() {

  },
  methods:{
    startDrag(evt, touch = false) {
      this.dragging = true;
      this.offset = 0;
      if(!touch){
        this.startDragPos = evt.clientX;
      }else{
        this.startDragPos = evt.touches[0].clientX;
      }
      this.progressDragPos = this.startDragPos
    },
    moveOnDrag(evt, touch = false){
      if(this.dragging){
        evt.preventDefault()
        let offset = 0;
        if(!touch) {
          offset = this.progressDragPos - evt.clientX;
        }else{
          offset = this.progressDragPos - evt.touches[0].clientX;
        }

        let scrollPos = this.$refs.scrollGoodsContainer.scrollLeft;
        this.$refs.scrollGoodsContainer.scrollLeft = scrollPos + offset

        if(!touch) {
          this.progressDragPos = evt.clientX;
        }else{
          this.progressDragPos = evt.touches[0].clientX;
        }
      }
    },
    onDrop(evt, touch = false) {
      if(this.dragging){
        evt.preventDefault()
        this.dragging = false;
      }
    },
  }
}
</script>

<style scoped lang="scss">
  .c_goods_container{
    width: 100%;
    height: max-content;
    padding: .6rem;
    display: flex;
    flex-direction: column;
    gap: .2rem;
    position: relative;
  }

  .c_goods_header{
    display: flex;
    padding: .4rem 1rem;
    justify-content: space-between;
    align-items: center;
  }

  .c_goods_title{
    text-align: left;
    font-size: 1.8rem;
  }

  .c_goods__divider{
    border-top: var(--theme-color-7) 4px solid;
    width: 25rem;
    height: 1rem;
  }

  .c_goods{
    position: relative;
    display: grid;
    height: max-content;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: repeat(auto-fill, 22rem);
    width: 100%;
    overflow-x: auto;
  }

  .c_good__counter{
    position: absolute;
    transform: translateX(-50%);
    width: max-content;
    height: 2rem;
    bottom: 0;
    left: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .c_good__marker{
    width: 1rem;
    cursor: pointer;
    height: 1rem;
    background-color: var(--dark-button-background);

    &_active{
      background-color: var(--theme-color-7);
      cursor: default;
    }
  }

  @media screen and (max-width: 1280px) {
    .c_goods{
      width: 100%;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: repeat(auto-fill, 22rem);
    }
  }

  @media screen and (max-width: 1200px) {
    .c_goods{
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: repeat(auto-fill, 24rem);
    }
  }

  @media screen and (max-width: 1100px) {
    .c_goods{
      grid-template-rows: repeat(auto-fill, 26rem);
    }
  }

  @media screen and (max-width: 992px) {
    .c_goods{
      width: 100%;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: repeat(auto-fill, 28rem);
    }
  }

  //MOBILE
  @media screen and (max-width: 768px) {
    .c_goods{
      width: 100%;
      height: 22rem;
      position: relative;
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      gap: 0;

      & > *{
        min-width: 95%;
        width: 100%;
      }

      &:active{
        cursor: grab;
      }

      &::-webkit-scrollbar{
        width: 0;
        height: 0;
      }
    }

    .c_goods__divider{
      width: 100%;
      height: .4rem;
    }
  }
</style>